main();

function main() {
  mobileNavs();
  megaMenus();
}

/**
 * Moves mobile menu and mobile categs
 * to the proper place
 *
 * @returns {void}
 */
function mobileNavs() {

  /** @type {HTMLUListElement | null} */
  const mobileCategs = document.getElementById('menu-mb__cat');

  /** @type {HTMLUListElement | null} */
  const mobileMenuItems = document.getElementById('menu-mb__ul');

  /** @type {HTMLDivElement | null} */
  const mobileMenuNav = document.getElementById('shopify-mb_nav');

  /** @type {HTMLDivElement | null} */
  const mobileCategNav = document.getElementById('shopify-mb_cat');

  mobileMenuNav.innerHTML = '';
  mobileCategNav.innerHTML = '';

  if (mobileMenuNav && mobileMenuItems) {
    mobileMenuNav.append(mobileMenuItems);
    mobileMenuItems.removeAttribute('style');
  }

  if (mobileCategNav && mobileCategs) {
    mobileCategNav.append(mobileCategs);
    mobileCategs.removeAttribute('style');
  }

}

/**
 * Moves the mega menus to the correct DOM location
 *
 * @returns {void}
 */
function megaMenus() {

  /** @type {HTMLDivElement | null} */
  const headerWrapper = document.querySelector('[data-site-header-wrapper]');
  if (!headerWrapper) return;

  /** @type {NodeListOf<HTMLDivElement>} */
  const megaMenuWrappers = (
    headerWrapper.querySelectorAll('[data-megamenu-content-wrapper]')
  );
  if (!megaMenuWrappers.length) return;

  for (const megaMenuWrapper of megaMenuWrappers) {

    /** @type {string | undefined} */
    const megaMenuId = megaMenuWrapper.dataset.forMegamenuId;
    if (!megaMenuId) {
      console.warn(
        'Mega Menu Id not found. Expecting data-for-megamenu-id attr'
      );
      continue;
    }

    /** @type {HTMLDivElement | null} */
    const megaMenuContent = document.querySelector(`[data-megamenu-id="${megaMenuId}"]`);
    if (!megaMenuContent) {
      console.warn(
        `Mega menu content not found for id: ${megaMenuId}`
      );
      continue;
    }

    megaMenuWrapper.replaceChildren(...megaMenuContent.children);

  }
}
